import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.styl';
import play from '../../assets/images/global-play.svg';
import pause from '../../assets/images/global-pause.svg';
import replay from '../../assets/images/global-replay.svg';

class Slideshow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      canPlayThrough: false,
      completedDuration: 0,
      currentSlide: 0,
      hasPlayedThrough: false,
      paused: true,
      slidesCanPlayThrough: this.props.slides.map(() => {
        return false;
      }),
      totalDuration: this.getDuration(this.props.slides)
    };

    this.updateDuration(props.slides);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.updateDuration(nextProps.slides);
  }

  getDuration = slides => {
    let totalDuration = 0;
    slides.forEach(slide => {
      totalDuration += slide.duration;
    });
    return totalDuration;
  };

  updateDuration = slides => {
    const totalDuration = this.getDuration(slides);
    if (totalDuration !== this.state.totalDuration) {
      this.setState({
        totalDuration: totalDuration
      });
    }
  };

  updateCanPlayThrough = (index, canPlayThrough) => {
    if (this.state.slidesCanPlayThrough[index] !== canPlayThrough) {
      let newSlidesCanPlayThrough = this.state.slidesCanPlayThrough;
      newSlidesCanPlayThrough[index] = canPlayThrough;
      const newState = { slidesCanPlayThrough: newSlidesCanPlayThrough };

      const slideshowCanPlayThrough = newSlidesCanPlayThrough.every(
        slideCanPlayThrough => {
          return slideCanPlayThrough;
        }
      );

      if (slideshowCanPlayThrough !== this.state.canPlayThrough) {
        newState.canPlayThrough = slideshowCanPlayThrough;
      }
      this.setState(newState);
    }
  };

  slideComplete = index => {
    const { currentSlide } = this.state;
    const newCompletedDuration =
      this.state.completedDuration + this.props.slides[currentSlide].duration;

    if (index !== currentSlide) {
      console.warn(
        'Slide ' +
          index +
          ' reported completion but Slideshow reports it is currently on slide ' +
          currentSlide
      );
    }

    if (index + 1 === this.props.slides.length) {
      this.setState({
        completedDuration: newCompletedDuration,
        paused: true,
        hasPlayedThrough: true
      });
      this.props.onCompletion();
    } else {
      this.setState({
        completedDuration: newCompletedDuration,
        currentSlide: currentSlide + 1
      });
    }
  };

  togglePause = () => {
    if (this.state.hasPlayedThrough) {
      const newState = {
        currentSlide: 0,
        completedDuration: 0,
        paused: !this.state.paused,
        hasPlayedThrough: this.state.paused
      };
      this.setState(newState);
    }
    this.setState({
      paused: !this.state.paused
    });
  };

  determineButtonImage = () => {
    const { paused, hasPlayedThrough } = this.state;
    if (hasPlayedThrough && paused) {
      return replay;
    } else if (paused) {
      return play;
    } else {
      return pause;
    }
  };

  render() {
    const {
      paused,
      completedDuration,
      totalDuration,
      currentSlide,
      hasPlayedThrough
    } = this.state;
    const completedFraction = completedDuration / totalDuration;

    // TODO: Would be nice to show Comet loading spinner when waiting for canPlayThrough to turn true

    // TODO: Could be nice to set Slideshow up with its own timer so that the progress bar advances at a steady clip
    //       instead of only between slides.

    return (
      <div className="slideshow">
        {this.props.slides.map((slide, i) => {
          const {
            SlideType, // don't pass type through
            ...slidePassthroughProps
          } = slide;

          const slideHidden = i !== currentSlide;
          const slidePaused = paused || slideHidden;

          return (
            <SlideType
              {...slidePassthroughProps}
              key={i}
              index={i}
              hidden={slideHidden}
              paused={slidePaused}
              updateCanPlayThrough={this.updateCanPlayThrough}
              onComplete={this.slideComplete}
              hasPlayedThrough={hasPlayedThrough}
            />
          );
        })}

        <div className="slideshow__progress-bar">
          <div
            className="slideshow__progress-bar__progress"
            style={{ transform: 'scaleX(' + completedFraction + ')' }}
          />
        </div>

        <div className="slideshow__controls">
          <button
            aria-pressed={!paused}
            className="slideshow__controls__play-pause"
            onClick={this.togglePause}
            // disabled={
            //   !this.state.canPlayThrough /* || this.state.hasPlayedThrough */
            // } // This is a curious situation - Having !this.state.canPlayThrough here disables the button on iOs, but not on desktop browsers or android. Switching the attribute to this.state.canPlayThrough will enable the button on iOs, but disable it on the other platforms.
          >
            <img src={this.determineButtonImage()} alt="" />

            <span className="comet-screenreader-only">Play Slideshow</span>
          </button>
        </div>
      </div>
    );
  }
}

Slideshow.defaultProps = {
  autoPlay: true
};

Slideshow.propTypes = {
  autoPlay: PropTypes.bool,
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      SlideType: PropTypes.func,
      duration: PropTypes.number
    })
  )
};

export default Slideshow;



// WEBPACK FOOTER //
// ../core/src/components/Slideshow/Slideshow.js